import { render, staticRenderFns } from "./ConfirmInvite.vue?vue&type=template&id=cc8d5278&scoped=true&"
import script from "./ConfirmInvite.vue?vue&type=script&lang=js&"
export * from "./ConfirmInvite.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmInvite.vue?vue&type=style&index=0&id=cc8d5278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8d5278",
  null
  
)

export default component.exports